import { PaywallPage } from '../../auth';
import { getUrls } from '../../config';
import { BOOKING_MODAL_VISIBLE } from '../../Bookings/actionTypes';
import { analyicsForAction } from '../../services/google-analytics/analyicsForAction';
import { closeLeaderboardModal } from '../../SummaryDashboard/actions';
import { Dispatch } from 'redux';
import { Platform } from 'react-native';

export const types = {
  RATE_WORKOUT_MODAL: 'ui/modal/rateHomeWorkoutModal',
  WEIGHT_TARGET_MODAL: 'ui/modal/weightTargetModal',
  REMOVE_TARGET_MODAL: 'ui/modal/removeTargetModal',
  BLOG_POST_MODAL_CLOSED: 'ui/modal/blogPostModalClosed',
  CLOSE_WEBVIEW_MODAL_PRESSED: 'CLOSE_WEBVIEW_MODAL_PRESSED',
  OPEN_WEBVIEW_MODAL: 'OPEN_WEBVIEW_MODAL',
};

export const hideLoading = () => ({
  type: 'ui/loading/hide',
});

export const showLoading = () => ({
  type: 'ui/toast/show',
});

export const showToastMessage = (toast) => ({
  type: 'ui/toast/show',
  toast,
});

export const hideToastMessage = () => ({
  type: 'ui/toast/hide',
});

export interface ICloseWebViewModalPressed {
  type: typeof types.CLOSE_WEBVIEW_MODAL_PRESSED;
}

export interface IOpenWebViewModal {
  type: typeof types.OPEN_WEBVIEW_MODAL;
  payload: {
    webviewModalUrl: string;
  }
}

export const closeWebViewModalPressed = () => ({
  type: types.CLOSE_WEBVIEW_MODAL_PRESSED,
});

export const toggleBookingsModal = (visible) => {
  return (dispatch) => {
    if (visible) {
      dispatch(closeAllModals());
    }
    dispatch({
      type: BOOKING_MODAL_VISIBLE,
      visible,
    });
  };
};

export const closeAllModals = () => {
  return (dispatch) => {
    dispatch(toggleBookingsModal(false));
    dispatch(closeLeaderboardModal());
    dispatch(toggleWeightTargetModal(false));
    dispatch({
      type: 'ui/modal/closeAll',
    });
  };
};

export const toggleWorkoutPartnersModal = (visible) => ({
  type: 'ui/modal/workoutPartners',
  visible,
});

export const toggleStrengthAssessmentModal = (visible) => ({
  type: 'ui/modal/strengthAssessment',
  visible,
});

export const togglePlansDetailScreen = (visible) => ({
  type: 'ui/modal/plansDetailScreenVisible',
  visible,
});

export const toggleWelcomeDashboardModal = (visible) => ({
  type: 'ui/modal/welcomeDashboardModalVisible',
  visible,
});

export const setPageTitle = (title) => ({
  type: 'ui/title',
  title,
});

export const togglePrivacySettingsModal = (visible) => ({
  type: 'ui/modal/privacySettingModalVisible',
  visible,
});

export const changeNutritionView = (view) => ({
  type: 'ui/nutritionView',
  view,
});

export const toggleMealModal = (visible, day) => {
  return (dispatch) => {
    if (visible) {
      dispatch(closeAllModals());
    }
    dispatch ({
      type: 'ui/modal/mealModal',
      visible,
      ...(visible ? analyicsForAction('nutrition_recipe_list_meal_select') : {}),
    })
  }
};

export const toggleNutritionStepsModal = (visible) => ({
  type: 'ui/modal/nutritionStrepsModal',
  visible,
  ...(visible ? analyicsForAction('nutrition_recipe_list_learn_select') : {}),
});

export const toggleFoodPreferencesModal = (visible, day) => ({
  type: 'ui/modal/foodPreferencesModal',
  visible,
});

export const toggleDieticianModal = (visible) => ({
  type: 'ui/modal/dieticianModal',
  visible,
  ...(visible ? analyicsForAction('nutrition_learn_nutritionscience_open') : {}),
});

export const toggleWorkoutHistoryModal = (visible) => ({
  type: 'ui/modal/workoutHistoryModal',
  visible,
});

export const togglePrivacyRemoveConfirmationModalVisible = (visible) => ({
  type: 'ui/modal/privacyRemoveConfirmationModalVisible',
  visible,
});

export const toggleWorkoutProgramSelectModalVisible = (visible) => ({
  type: 'ui/modal/workoutProgramSelectModalVisible',
  visible,
});

export const notificationsScreenOpened = () => ({
  type: 'ui/modal/notificationScreenOpened',
  ...analyicsForAction('notifications_topmenu_selected'),
});

export const InfoScreenOpened = () => ({
    type: 'ui/modal/infoScreenOpened',
    ...analyicsForAction('helptopicon_topmenu_selected'),
  });

export const toggleStatsGraphModalVisible = (visible) => ({
  type: 'ui/modal/statsGraphModalVisible',
  visible,
});

export const toggleScanReportModalVisible = (visible) => ({
  type: 'ui/modal/scanReportModalVisible',
  visible,
});

export const toggleFirstVideoModalVisible = (visible) => ({
  type: 'ui/modal/firstVideoModalVisible',
  visible,
});

export const mainTabSelected = (tabName) => ({
  type: 'ui/mainTabSelect',
  ...analyicsForAction(`main_tab_selected_${tabName}`),
});

export const toggleShoppingListEditModalVisible = (visible) => ({
  type: 'ui/modal/shoppingListEditModalVisible',
  visible,
  ...(visible ? analyicsForAction('nutrition_shoppinglist_edit_start') : {}),

});

export const toggleHeartRateMonitorModalVisible = (visible) => ({
  type: 'ui/modal/heartRateMonitorModalVisible',
  visible,
});

export const toggleHeartRateMonitorModalStudioVisible = (visible) => {
  return (dispatch) => {
    if (visible) {
      dispatch(closeAllModals());
    }
    dispatch({ type: 'ui/modal/heartRateMonitorModalStudioVisible', visible });
  };
};

export const toggleScreenMirroringModalVisible = (visible) => ({
  type: 'ui/modal/screenMirroringModalVisible',
  visible,
});
export const toggleTrackingOnboardingModalVisible = (visible) => ({
  type: 'ui/modal/trackingOnboardingModalVisible',
  visible,
});
export const toggleUserProfileModalVisible = (visible) => ({
  type: 'ui/modal/userProfileModalVisible',
  visible,
});

export const toggleOnboardingInviteModal = (visible) => ({
  type: 'ui/modal/onboardingInviteModal',
  visible,
});

export const toggleBodyScanModal = (visible) => ({
  type: 'ui/modal/bodyscanModal',
  visible,
});

export const toggleBookingCompleteOnboardingModal = (visible) => ({
  type: 'ui/modal/bookingCompleteOnboardingModal',
  visible,
});

export const toggleRateHomeWorkoutModal = (visible) => {
  return {
    type: types.RATE_WORKOUT_MODAL,
    visible,
  };
};

export const toggleSkillLevelSelectModal = (visible) => ({
  type: 'ui/modal/skillLevelSelectModal',
  visible,
});

export const openWorkoutIntroVideo = () => ({
  type: 'ui/modal/workoutIntroVideo',
  ...analyicsForAction('dashboard_workout_intro_video_open'),
});
export const closeWorkoutIntroVideo = ()=>({
  type: 'ui/modal/close/workoutIntroVideo',
  ...analyicsForAction('dashboard_workout_intro_video_close'),
});

export const toggleWeightTargetModal = (visible) => {
  return (dispatch) => {
    if (visible) {
      dispatch(closeAllModals());
    }
    dispatch({
      type: types.WEIGHT_TARGET_MODAL,
      visible,
    });
  };
};

const openWebViewModal = (webviewModalUrl: string) => ({
  type: types.OPEN_WEBVIEW_MODAL,
  payload: { webviewModalUrl },
});

export const termsAndConditionsButtonPressedAction = () => (
  (dispatch: Dispatch<IOpenWebViewModal>) => {
    const { ALL_TERMS_AND_CONDITIONS } = getUrls();
    if (Platform.OS === 'web') {
      window.open(ALL_TERMS_AND_CONDITIONS, '_blank');
    } else {
      dispatch(openWebViewModal(ALL_TERMS_AND_CONDITIONS));
    }
  }
);

export const toggleRemoveTargetModal = (visible) => ({
  type: types.REMOVE_TARGET_MODAL,
  visible,
});

export const blogPostModalClosed = () => ({
  type: types.BLOG_POST_MODAL_CLOSED,
});
